import React from 'react'
import Footer from '../../Footer'
import fig1 from '../../../img/web/creative/fig1.gif'
import fig2 from '../../../img/web/creative/fig2.png'
import '../Proj.css'


export default class ProjCreative extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
          
                <div className='proj-wrap-86'>
                    <div id='splat-title'>
                        <h1>Design Method</h1>
                    </div>
                    <div className='proj-fig'>
                        <img src={fig1} />
                    </div>
                    <p>
                    A website that introduces design methods to help inspire new ideas.
                    It can filter and compare different methods to help the users find the best one to use.
                    </p>
                    <div className='proj-fig'>
                        <img src={fig2} />
                    </div>
                    
                    <Footer back={true}/>
                </div>
            </div>
        )
    }
}